import { API_URL } from '@api/apiDictionary';
import { FacilityType } from '@dynamika-shared/types/facility';
import { RESTClient, RESTClientMock } from '@api/client';
import { USE_API_MOCKS } from '../env';
import { fetchFacilitiesMock } from '@api/mocks/facilites';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchFacilityList = async (name?: string) => {
    if (USE_API_MOCKS) {
        fetchFacilitiesMock();
    }
    return api.get<FacilityType[]>(API_URL.facilities, { params: { name } });
};
